export class CreateReferralRequest {
  title: string;
  givenName: string;
  familyName: string;
  email: string;
  telephone: string;
  programme: string;
  venues: string[];
  notes: string;
}
